/**
 * Global org-members query for assignee/user pickers (record USER fields,
 * tickets, inbox). Shares the `['org-users', params]` cache key with the
 * inbox's local hook so both read the same cache entry.
 *
 * May error with `403` for under-permissioned roles — consumers read
 * `isError` and degrade (hide the picker / show a fallback).
 */
import { useQuery } from '@tanstack/react-query';

import { getAllUsers, type IListUsersParams, type IListUsersResult } from '@/api/services/user.api';

export function useOrganizationUsers(params?: IListUsersParams) {
    return useQuery<IListUsersResult>({
        queryKey: ['org-users', params],
        queryFn: () => getAllUsers(params),
        staleTime: 5 * 60 * 1000,
        retry: false,
    });
}
